export const CompanyVersion = [
  // {
  //   company:"ראלינס",
  //   dashbord:"http://ralinsmobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://ralinsmobility.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:10152.1,
  //   version:430
  // },
  {
    company: 'קנקון מקומי',
    dashbord:
      'http://cancunmobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord',
    link: 'http://cancunmobility.s3-website.eu-central-1.amazonaws.com',
    server: 'פרנקפורט',
    order: 0,
    version: 115,
  },

  {
    company: 'אחאב ',
    dashbord:
      'http://ahavmobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord',
    link: 'http://ahavmobility.s3-website.eu-central-1.amazonaws.com',
    server: 'פרנקפורט',
    order: 0,
    version: 303,
  },

  {
    company: ' טובול קרמיקה',
    dashbord:
      'http://tobulkeramika.s3-website.us-east-2.amazonaws.com/mobilitydashbord',
    link: 'http://tobulkeramika.s3-website.us-east-2.amazonaws.com',
    server: 'אוהיו',
    order: 0,
    version: 50.7,
  },

  // {
  //   company:"שניב",
  //   dashbord:"http://shaniv.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://shaniv.s3-website.eu-central-1.amazonaws.com",
  //   server:"אוהיו",
  //   order:10025,
  //   version:430
  // },
];

export const Companies = [
  // // {
  // //   company:"בדיקת סטרינג ",
  // //   dashbord:"http://stringcheck.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  // //   link:"http://stringcheck.s3-website.eu-central-1.amazonaws.com",
  // //   server:"פרנקפורט",
  // //   order:0,
  // //   version:2000
  // // },
  // // {
  // //   company:"אגם סחר ",
  // //   dashbord:"http://agamsahar.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  // //   link:"http://agamsahar.s3-website.us-east-2.amazonaws.com",
  // //   server:"אוהיו",
  // //   order:0,
  // //   version:310.2
  // // },
  // {
  //   company:"עשינו עסק ",
  //   dashbord:"http://asinoesek.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  //   link:"http://asinoesek.s3-website.us-east-2.amazonaws.com",
  //   server:"אוהיו",
  //   order:0,
  //   version:203
  // },
  // // {
  // //   company:" ממתקי אביה",
  // //   dashbord:"http://mamtakeyavia.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  // //   link:"http://mamtakeyavia.s3-website.us-east-2.amazonaws.com",
  // //   server:"אוהיו",
  // //   order:0,
  // //   version:303
  // // },
  // {
  //   company:"קראווני טולס",
  //   dashbord:"http://karavanitools.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  //   link:"http://karavanitools.s3-website.us-east-2.amazonaws.com",
  //   server:"אוהיו",
  //   order:0,
  //   version:126
  // },
  // {
  //   company:"בנעמי",
  //   dashbord:"http://benaminew.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://benaminew.s3-website.eu-central-1.amazonaws.com",
  //   server:"אוהיו",
  //   order:0,
  //   version:112
  // },
  // {
  //   company:"שימורי עדן",
  //   dashbord:"http://shimoreieden.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  //   link:"http://shimoreieden.s3-website.us-east-2.amazonaws.com",
  //   server:"אוהיו",
  //   order:0,
  //   version:112
  // },
  // {
  //   company:"יהודה שיווק",
  //   dashbord:"http://yehudashivok.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  //   link:"http://yehudashivok.s3-website.us-east-2.amazonaws.com",
  //   server:"אוהיו",
  //   order:0,
  //   version:109
  // },
  // // {
  // //   company:"נשם מקומי",
  // //   dashbord:"http://neshemmobility.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  // //   link:"http://neshemmobility.s3-website.us-east-2.amazonaws.com",
  // //   server:"אוהיו",
  // //   order:0,
  // //   version:310.2
  // // },
  // {
  //   company:"די אס תאורה",
  //   dashbord:"http://dsteora.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  //   link:"http://dsteora.s3-website.us-east-2.amazonaws.com",
  //   server:"אוהיו",
  //   order:0,
  //   version:103
  // },
  // {
  //   company:"ברייטקום",
  //   dashbord:"http://britecommobility.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  //   link:"http://britecommobility.s3-website.us-east-2.amazonaws.com",
  //   server:"אוהיו",
  //   order:0,
  //   version:306.1
  // },
  // {
  //   company:"יעקבי מקומי",
  //   dashbord:"http://yaakobimobility.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  //   link:"http://yaakobimobility.s3-website.us-east-2.amazonaws.com",
  //   server:"אוהיו",
  //   order:0,
  //   version:201
  // },
  // {
  //   company:"כפר בן שמן",
  //   dashbord:"http://kfarbenshemen.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  //   link:"http://kfarbenshemen.s3-website.us-east-2.amazonaws.com",
  //   server:"אוהיו",
  //   order:0,
  //   version:105.1
  // },
  // //   {
  // //   company:"קסטל",
  // //   dashbord:"http://castelmobility.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  // //   link:"http://castelmobility.s3-website.us-east-2.amazonaws.com",
  // //   server:"אוהיו",
  // //   order:0,
  // //   version:99.2
  // // },
  // {
  //   company:"יקב פלם",
  //   dashbord:"http://yekevpelemmobility.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  //   link:"http://yekevpelemmobility.s3-website.us-east-2.amazonaws.com",
  //   server:"אוהיו",
  //   order:0,
  //   version:114
  // },
  // {
  //   company:"אלפיטל",
  //   dashbord:"http://alfitalmobility.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  //   link:"http://alfitalmobility.s3-website.us-east-2.amazonaws.com",
  //   server:"אוהיו",
  //   order:0,
  //   version:99.8
  // },
  // {
  //   company:"פופקו",
  //   dashbord:"http://popkomobility.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  //   link:"http://popkomobility.s3-website.us-east-2.amazonaws.com",
  //   server:"אוהיו",
  //   order:0,
  //   version:99.7
  // },
  // {
  //   company:"פאר הבשר",
  //   dashbord:"http://peerabasar.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  //   link:"http://peerabasar.s3-website.us-east-2.amazonaws.com",
  //   server:"אוהיו",
  //   order:0,
  //   version:107
  // },
  // {
  //   company:"פולק אנרגיה ",
  //   dashbord:"http://polakenergy.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://polakenergy.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:97.0
  // },
  // {
  //   company:"אגדת ",
  //   dashbord:"http://agadatmobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://agadatmobility.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:306.1
  // },
  // {
  //   company:"זוארץ ",
  //   dashbord:"http://zuaretzmobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://zuaretzmobility.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:95.0
  // },
  // {
  //   company:"פרוגרס דגת הים ",
  //   dashbord:"http://progressdagat.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://progressdagat.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:93.0
  // },
  // {
  //   company:"אמונה ",
  //   dashbord:"http://amonamobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://amonamobility.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:93.0
  // },
  // {
  //   company:"פטקס ",
  //   dashbord:"http://pateksmobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://pateksmobility.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:128
  // },
  // {
  //   company:"דנלר ",
  //   dashbord:"http://denlermobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://denlermobility.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:93.0
  // },
  // {
  //   company:"תמרה רטבים",
  //   dashbord:"http://tamararetavim.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://tamararetavim.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:93.0
  // },
  // {
  //   company:"ניצן מותגי מזון",
  //   dashbord:"http://nitzanmm.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://nitzanmm.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:94
  // },
  // // {
  // //   company:"דולינה מקומי",
  // //   dashbord:"http://dolinamobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  // //   link:"http://dolinamobility.s3-website.eu-central-1.amazonaws.com",
  // //   server:"פרנקפורט",
  // //   order:0,
  // //   version:310.2
  // // },
  // // {
  // //   company:"צור סוכניות מקומי",
  // //   dashbord:"http://zormobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  // //   link:"http://zormobility.s3-website.eu-central-1.amazonaws.com",
  // //   server:"פרנקפורט",
  // //   order:0,
  // //   version:311
  // // },
  // {
  //   company:"עתרן",
  //   dashbord:"http://atranmobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://atranmobility.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:99.8
  // },
  // // {
  // //   company:"זן לכל יכין",
  // //   dashbord:"http://zenlacolyachin.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  // //   link:"http://zenlacolyachin.s3-website.eu-central-1.amazonaws.com",
  // //   server:"פרנקפורט",
  // //   order:0,
  // //   version:99.8
  // // },
  // // {
  // //   company:"סול מקומי",
  // //   dashbord:"http://solmobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  // //   link:"http://solmobility.s3-website.eu-central-1.amazonaws.com",
  // //   server:"פרנקפורט",
  // //   order:0,
  // //   version:306
  // // },
  // {
  //   company:"זאוס מקומי",
  //   dashbord:"http://zeus-mobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://zeus-mobility.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:114
  // },
  // {
  //   company:"מורדכי",
  //   dashbord:"http://mordechaimobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://mordechaimobility.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:114
  // },
  // {
  //   company:"לביא",
  //   dashbord:"http://lavimobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://lavimobility.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:97.0
  // },
  // // {
  // //   company:"אביבי",
  // //   dashbord:"http://avivimobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  // //   link:"http://avivimobility.s3-website.eu-central-1.amazonaws.com",
  // //   server:"פרנקפורט",
  // //   order:0,
  // //   version:62.3
  // // },
  // {
  //   company:"אפולו",
  //   dashbord:"http://apolomobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://apolomobility.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:306.1
  // },
  // {
  //   company:"מנורה",
  //   dashbord:"http://manoramobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://manoramobility.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:98.1
  // },
  // {
  //   company:"אפל",
  //   dashbord:"http://applemobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://applemobility.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:302
  // },
  // {
  //   company:"אלור מקומי",
  //   dashbord:"http://alor.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://alor.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:102
  // },
  // // {
  // //   company:"כהן פור",
  // //   dashbord:"http://cohenfor.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  // //   link:"http://cohenfor.s3-website.eu-central-1.amazonaws.com",
  // //   server:"פרנקפורט",
  // //   order:0,
  // //   version:9.7
  // // },
  // // {
  // //   company:"ק.א שוקולד",
  // //   dashbord:"http://kachocolate.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  // //   link:"http://kachocolate.s3-website.eu-central-1.amazonaws.com",
  // //   server:"פרנקפורט",
  // //   order:0,
  // //   version:310.5
  // // },
  // {
  //   company:"אול טישו",
  //   dashbord:"http://allticho.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://allticho.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:9.8
  // },
  // {
  //   company:"טבע קום",
  //   dashbord:"http://tevacom.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  //   link:"http://tevacom.s3-website.us-east-2.amazonaws.com",
  //   server:"אוהיו",
  //   order:0,
  //   version:94.0
  // },
  // {
  //   company:"רמי לייט",
  //   dashbord:"http://ramilightaddison.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  //   link:"http://ramilightaddison.s3-website.us-east-2.amazonaws.com",
  //   server:"אוהיו",
  //   order:0,
  //   version:302
  // },
  // {
  //   company:"שימורי המרכז מקומי",
  //   dashbord:"http://shimoreiamerkaz.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://shimoreiamerkaz.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:310.5
  // },
  // {
  //   company:"ספרק טויס",
  //   dashbord:"http://sparktoys.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://sparktoys.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:108.5
  // },
  // // {
  // //   company:"ברוס",
  // //   dashbord:"http://brucemobility.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  // //   link:"http://brucemobility.s3-website.us-east-2.amazonaws.com",
  // //   server:"אוהיו",
  // //   order:0,
  // //   version:0
  // // },
  // {
  //   company:"ספדיני",
  //   dashbord:"http://spediniozgom.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://spediniozgom.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:303
  // },
  // {
  //   company:"אנשי הזית",
  //   dashbord:"http://ansheiazaitmnew.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://ansheiazaitmnew.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:102.0
  // },
  // {
  //   company:"זם צמח",
  //   dashbord:"http://zenzemah.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  //   link:"http://zenzemah.s3-website.us-east-2.amazonaws.com",
  //   server:"אוהיו",
  //   order:0,
  //   version:0
  // },
  // {
  //   company:"מיט פלייס",
  //   dashbord:"http://meetplace.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  //   link:"http://meetplace.s3-website.us-east-2.amazonaws.com",
  //   server:"אוהיו",
  //   order:0,
  //   version:0
  // },
  // {
  //   company:"רביאת",
  //   dashbord:"http://raviat.s3-website.us-east-2.amazonaws.com/mobilitydashbord",
  //   link:"http://raviat.s3-website.us-east-2.amazonaws.com",
  //   server:"אוהיו",
  //   order:0,
  //   version:125
  // },
  // {
  //   company:"צנובר",
  //   dashbord:"http://znobar.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://znobar.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:310.5
  // },
  // // {
  // //   company:"צעצועי דורון מקומי",
  // //   dashbord:"http://dorontoys.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  // //   link:"http://dorontoys.s3-website.eu-central-1.amazonaws.com",
  // //   server:"פרנקפורט",
  // //   order:0,
  // //   version:36.0
  // // },
  // {
  //   company:"וול דאן",
  //   dashbord:"http://welldonemobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://welldonemobility.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:99.7
  // },
  // {
  //   company:"רדע תמרי ",
  //   dashbord:"http://radatamari.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://radatamari.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:99.8
  // },
  // {
  //   company:"שבי ",
  //   dashbord:"http://shabibeitbasar.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://shabibeitbasar.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:46.0
  // },
  // // {
  // //   company:"פרוגרס",
  // //   dashbord:"http://progresmobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  // //   link:"http://progresmobility.s3-website.eu-central-1.amazonaws.com",
  // //   server:"פרנקפורט",
  // //   order:0,
  // //   version:114
  // // },
  // {
  //   company:"סיני מקומי",
  //   dashbord:"http://daledlamessini.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  //   link:"http://daledlamessini.s3-website.eu-central-1.amazonaws.com",
  //   server:"פרנקפורט",
  //   order:0,
  //   version:108.2
  // },
  // // {
  // //   company:"געש",
  // //   dashbord:"http://gaashmobility.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  // //   link:"http://gaashmobility.s3-website.eu-central-1.amazonaws.com",
  // //   server:"פרנקפורט",
  // //   order:0,
  // //   version:1
  // // },
  // // {
  // //   company:"מור ים",
  // //   dashbord:"http://mor-yam.s3-website.eu-central-1.amazonaws.com/mobilitydashbord",
  // //   link:"http://mor-yam.s3-website.eu-central-1.amazonaws.com",
  // //   server:"פרנקפורט",
  // //   order:0,
  // //   version:310.5
  // // },
];
